import * as React from 'react';

const BottomBlobSvg = (props: React.SVGProps<SVGSVGElement>) => (
    <svg
        width="150"
        height="216"
        viewBox="0 0 150 216"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
    >
        <path
            id="Vector"
            d="M105.149 143.73C104.287 163.002 120.724 176.789 119.51 203.935C117.567 247.366 -1.41598 152.556 0.429714 111.291C1.53459 86.5889 66.9153 121.014 67.1946 114.769C67.4739 108.524 29.9109 76.047 30.4935 63.0201C31.2462 46.1919 84.9999 77.1942 84.9999 77.1942C84.9999 77.1942 29.0784 26.7374 30.0135 5.83023C31.082 -18.0575 152.785 36.3623 149.47 110.476C147.698 150.112 106.096 122.558 105.148 143.737L105.149 143.73ZM29.6076 39.9613C32.1772 35.3517 28.9137 27.5691 22.3221 22.5931C15.7307 17.611 8.30319 17.312 5.73355 21.9216C3.16391 26.5312 6.42739 34.3139 13.019 39.2898C19.6104 44.272 27.0379 44.5709 29.6076 39.9613Z"
            fill="#ACC7CC"
        />
    </svg>
);

BottomBlobSvg.displayName = 'BottomBlobSvg';
export default BottomBlobSvg;
